/**
 * Semantic tones for status pills. The color lives in the tinted fill; the text is always the
 * theme foreground, so labels meet WCAG AA (4.5:1) in light and dark themes. Pair with
 * `labelChipClassName()` for shape.
 */
export type StatusPillTone = 'success' | 'warning' | 'error' | 'info' | 'neutral' | 'muted';

const TONE_CLASSES: Record<StatusPillTone, string> = {
  success: 'bg-status-success-muted text-foreground',
  warning: 'bg-status-warning-muted text-foreground',
  error: 'bg-status-error-muted text-foreground',
  info: 'bg-status-info-muted text-foreground',
  neutral: 'bg-status-neutral-muted text-foreground',
  muted: 'bg-muted text-foreground',
};

export function statusPillClass(tone: StatusPillTone): string {
  return TONE_CLASSES[tone];
}
